import { UserHelper } from "@/helpers/user.helper";
import { ActionService } from "@/services/action.service";
import { AppConfigService } from "@/services/app-config.service";
import { NgTemplateOutlet } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { ModalBaseComponent } from "../base/modal-base/modal-base.component";

export interface IntroDialogData {
  forceIndividual: false;
  forceProfessional: false;
  forceNotary: false;
  forceRealEstate: false;
  forceRealEstateKw: false;
  forceIndividualWithShare: false;
  userHasShare: false;
}

@Component({
  selector: "app-intro-dialog",
  templateUrl: "./intro-dialog.component.html",
  styleUrls: ["./intro-dialog.component.scss"],
  standalone: true,
  imports: [
    MatDialogModule,
    ModalBaseComponent,
    NgTemplateOutlet,
    MatButtonModule,
    TranslateModule,
  ],
})
export class IntroDialogComponent implements OnInit {
  dialogTitle = "Bien démarrer en 3 minutes !";

  constructor(
    public dialogRef: MatDialogRef<IntroDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IntroDialogData,
    private appConfigService: AppConfigService,
    private userHelper: UserHelper,
    private actionService: ActionService,
    private router: Router
  ) {}

  isGuest = false;
  isIndividual = false;
  isIndividualWithShare = false;
  isProfessional = false;
  isNotary = false;
  isRealEstate = false;
  isRealEstateKw = false;

  ngOnInit() {
    if (this.appConfigService.isDemo()) {
      this.isGuest = true;
    } else {
      this.isIndividual =
        (this.userHelper.isIndividual() && !this.data.userHasShare) ||
        this.data.forceIndividual;
      this.isIndividualWithShare =
        (this.userHelper.isIndividual() && this.data.userHasShare) ||
        this.data.forceIndividualWithShare;
      this.isProfessional =
        this.userHelper.isProfessional() || this.data.forceProfessional;
      this.isNotary = this.userHelper.isNotary() || this.data.forceNotary;
      this.isRealEstateKw =
        this.userHelper.isRealEstateKw() || this.data.forceRealEstateKw;
      this.isRealEstate =
        this.userHelper.isRealEstate() ||
        this.data.forceRealEstate ||
        this.isRealEstateKw;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  showWelcomMessage() {
    // close the dialog
    this.dialogRef.close(true);
    // choose the right article

    let articleId = environment.WELCOME_ARTICLE_ID_INDIVIDUAL;
    if (this.isRealEstate || this.isRealEstateKw) {
      articleId = environment.WELCOME_ARTICLE_ID_REALTOR;
    } else if (this.isProfessional) {
      articleId = environment.WELCOME_ARTICLE_ID_PROFESSIONAL;
    } else if (this.isNotary) {
      articleId = environment.WELCOME_ARTICLE_ID_NOTARY;
    } else if (this.isIndividualWithShare) {
      articleId = environment.WELCOME_ARTICLE_ID_INDIVIDUAL_WITH_SHARE;
    }

    this.actionService.showHelpScoutArticle(articleId);
  }
}
